import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useProjectId from '@hooks/useProjectId';
import { OrderType } from '@models/order';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const TOKYO_PLATZ_ID = import.meta.env.VITE_TOKYO_PLATZ_ID;
const PAIKS_DABANG_ID = import.meta.env.VITE_PAIKS_DABANG_ID;
const TOKYO_PLATZ_HANZOMON_ID = '0rn8w979sjm5a';

function OrderTypeSelector() {
    const { orderType, shopId } = useCalculatedRequest();
    const dispatch = useDispatch();
    const { t } = useTranslation('order');
    const updateOrderType = (ot: OrderType) => {
        dispatch(orderActions.setOrderType(ot));
    };
    const projectId = useProjectId();
    const takeOutOnlyProjectIds = [TOKYO_PLATZ_ID, PAIKS_DABANG_ID];
    const takeoutOnlyExcludeShopIds = [TOKYO_PLATZ_HANZOMON_ID];

    const showInShop = !takeOutOnlyProjectIds.includes(projectId)
        || takeoutOnlyExcludeShopIds.includes(shopId);

    return (
        <Container>
            <Text fontWeight='bold' size='lg'>{t('orderType.title')}</Text>
            <Column spacing={8}>
                <Radio value='TAKE_OUT' isSelected={orderType === 'TAKE_OUT'}
                    onChange={() => updateOrderType('TAKE_OUT')}>
                    {t('orderType.takeOut')}
                </Radio>
                {/* TODO 매장별 주문 방법 설정 후 제거 */}
                {showInShop && (
                    <Radio value='IN_SHOP' isSelected={orderType === 'IN_SHOP'}
                        onChange={() => updateOrderType('IN_SHOP')}>
                        {t('orderType.inShop')}
                    </Radio>
                )}
            </Column>
        </Container>
    );
}

const Container = styled.div`
    padding: 20px 20px 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
`;

export default OrderTypeSelector;
